import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function FaqAccordion({ items, testPrefix = "faq" }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="divide-y divide-silver/50 border-y border-silver/50">
      {items.map((it, i) => (
        <div key={i}>
          <button
            type="button"
            aria-expanded={open === i}
            data-testid={`${testPrefix}-item-${i}`}
            onClick={() => setOpen(open === i ? -1 : i)}
            className="flex w-full items-center justify-between gap-6 py-5 text-left"
          >
            <span className="font-display text-base sm:text-lg font-semibold text-ink">{it.q}</span>
            <span
              aria-hidden="true"
              className={`relative h-5 w-5 shrink-0 text-cobalt transition-transform duration-300 ${
                open === i ? "rotate-45" : ""
              }`}
            >
              <span className="absolute left-1/2 top-0 h-full w-0.5 -translate-x-1/2 bg-current" />
              <span className="absolute top-1/2 left-0 w-full h-0.5 -translate-y-1/2 bg-current" />
            </span>
          </button>
          <AnimatePresence initial={false}>
            {open === i && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.25, ease: "easeOut" }}
                className="overflow-hidden"
              >
                <p className="pb-6 pr-8 sm:pr-16 text-ink/75 leading-relaxed">{it.a}</p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}
